import type { SalesAction } from '@shared/types/sales-action';

/**
 * 対象弁護士の必須対象 (86eya0dva 書き込み整合の不変条件)。行自身のアンカー弁護士
 * (行の target が弁護士の場合のその弁護士) の id を返す。firm アンカー行にはアンカー
 * 弁護士という概念が無いため undefined。
 *
 * 一覧・詳細のどちらでも「閲覧中の画面の弁護士」ではなく行ごとの保存アンカーを見る
 * (firm アンカー行を弁護士詳細から開いても、閲覧中の弁護士はロックしない)。
 */
export function anchorLawyerId(
  action: Pick<SalesAction, 'target'>,
): string | undefined {
  return action.target.kind === 'lawyer' ? action.target.id : undefined;
}
